export const PARTNER_POSTBACK_FORM_TYPES = {
    ADD: 'add',
    UPDATE: 'update',
}
